/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_3_AInputs */

const en_cp_faq_3_a = /** @type {(inputs: Cp_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The task next → start → verify → complete loop runs through the open-source CLI/MCP and works with Claude Code, Cursor, Copilot, Codex, or by hand.`)
};

const id_cp_faq_3_a = /** @type {(inputs: Cp_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Loop task next → start → verify → complete jalan lewat CLI/MCP open-source dan bisa dipakai dengan Claude Code, Cursor, Copilot, Codex, atau dikerjakan manual.`)
};

/**
* | output |
* | --- |
* | "No. The task next → start → verify → complete loop runs through the open-source CLI/MCP and works with Claude Code, Cursor, Copilot, Codex, or by hand." |
*
* @param {Cp_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_3_a = /** @type {((inputs?: Cp_Faq_3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_3_a(inputs)
	return en_cp_faq_3_a(inputs)
});